module.exports = __webpack_public_path__ + "static/media/movieType-animated.e6c5207c.jpg";